module.exports = __webpack_public_path__ + "static/bottom-f5ad4e077e4e17a0fa525006c3ccb9c5.png";